import styled, { CSSObject } from 'styled-components';
import { ICalloutPositionStyles } from '../callout-types';

interface ICalloutBeakProps {
    beakWidth: number;
    beakStyles: ICalloutPositionStyles['beakStyles'];
}

export const CalloutBeak = styled.span.attrs((props: ICalloutBeakProps) => props)`
    ${({ beakStyles }) => beakStyles as CSSObject}
    width: ${({ beakWidth }) => beakWidth}px;
    height: ${({ beakWidth }) => beakWidth}px;
    background-color: ${({ theme: { callout: { colors } } }) => colors.backgroundColor};
    position: absolute;
    box-shadow: inherit;
    border: inherit;
    box-sizing: border-box;
    transform: rotate(45deg);
    z-index: 0;
`;
